import * as React from "react";
import type { SVGProps } from "react";
const SvgPresentation02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.6 16.2 7.8 21m8.794-.067-2.122-4.667m-.072-6.109L11.946 12.6m0 0L9.6 10.268m2.346 2.332v-6M4.8 16.2a2.4 2.4 0 0 1-2.4-2.4V5.4A2.4 2.4 0 0 1 4.8 3h14.4a2.4 2.4 0 0 1 2.4 2.4v8.4a2.4 2.4 0 0 1-2.4 2.4z"
    />
  </svg>
);
export default SvgPresentation02;
